<template>
  <th v-if="isHeader">
    {{'Actions' | translate}}
  </th>
  <td v-else>
    <div class="custom-actions">
      <button class="btn btn-outline-secondary btn-sm mr-1" @click="itemAction('edit', rowData, rowIndex)" :title="$t('Edit')">
        <i class="fa fa-edit"></i>
      </button>
    </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction (action, data, index) {
      this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id })
    },
    toggleStatus (data, index) {
      const newStatus = data.status === 'active' ? 'archived' : 'active'
      const actionText = newStatus === 'archived' ? this.$t('deactivate') : this.$t('activate')

      if (confirm(this.$t('Are you sure you want to') + ' ' + actionText + ' ' + this.$t('this risk question?'))) {
        this.$http.put('risk-questions/' + data.id, {
          risk_question: { status: newStatus }
        }).then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: 'full',
              text: response.data.msg,
              type: 'success'
            })
            // Refresh the table
            this.$parent.$parent.$refs.riskquestiontable.$refs.vuetable.refresh()
          }
        }).catch((error) => {
          console.error('Error toggling status:', error)
          this.$notify({
            group: 'full',
            text: this.$t('Error updating risk question status'),
            type: 'error'
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.custom-actions {
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-sm {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  min-width: 32px;
}
</style>


// WEBPACK FOOTER //
// VueTableRiskActions.vue?60f67872